import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../src/api/api_helper";

/* ---------- Types ---------- */

interface UserProfile {
  token?: string;
  [key: string]: any;
}

interface UseProfileResult {
  userProfile: UserProfile | null;
  loading: boolean;
  token?: string;
}

/* ---------- Hook ---------- */

const useProfile = (): UseProfileResult => {
  const userProfileSession: UserProfile | null = getLoggedinUser();

  const token: string | undefined = userProfileSession?.token;

  const [loading, setLoading] = useState<boolean>(
    userProfileSession ? false : true
  );

  const [userProfile, setUserProfile] = useState<UserProfile | null>(
    userProfileSession
  );

  useEffect(() => {
    const userProfileSession: UserProfile | null = getLoggedinUser();

    const token: string | undefined = userProfileSession?.token;

    setUserProfile(userProfileSession);
    setLoading(token ? false : true);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
